import formInputsTypes from '../simulatorConstant';
const MainOuvreDataPorte = {
  id: 'OptionsPorteGarage',
  type: formInputsTypes?.CHECKBOX_INPUT,
  label: "Autre main d'œuvre",
  name: 'Options',
  className: 'col-12 mt-6',
  classGroup: 'simulator-check',
  nextStepData: false,
  nextStep: false,
  options: [
    {
      id: 'Création Porte de garage complet',
      value: 'Création Porte de garage complet',
      label: 'Création Porte de garage complet',
      isInline: true,
      nextStep: false,
      lst_price: 0,
      product_id: 9495,
      description: '- Création complète d’une porte de garage.',
    },
    {
      id: 'Ouverture du coffre non difficile',
      label: 'Ouverture du capotage (non difficile)',
      value: 'Ouverture du coffre non difficile',
      isInline: true,
      nextStep: false,
      lst_price: 0,
      product_id: 9495,
      description: '- Ouverture du capotage / accès au mécanisme de la porte de garage (accès standard).',
    },
    {
      id: 'Ouverture du coffre difficile',
      label: 'Ouverture du capotage (difficile)',
      value: 'Ouverture du coffre difficile',
      isInline: true,
      nextStep: false,
      lst_price: 0,
      product_id: 9495,
      description: '- Ouverture du capotage / accès au mécanisme de la porte de garage (accès difficile).',
    },
    {
      id: 'Tirage de ligne électrique',
      label: 'Tirage de ligne électrique',
      value: 'Tirage de ligne électrique',
      lst_price: 0,
      isInline: true,
      product_id: 9495,
      description: '- Tirage de la ligne électrique pour alimentation du moteur de la porte de garage.',
    },
    {
      id: 'Mise en place des agrafes',
      label: 'Mise en place des fixations',
      value: 'Mise en place des agrafes',
      lst_price: 0,
      isInline: true,
      product_id: 9495,
      description: '- Mise en place des fixations et éléments de liaison des panneaux / tablier de la porte de garage.',
    },
    {
      id: 'Branchement électrique',
      label: 'Branchement électrique',
      value: 'Branchement électrique',
      lst_price: 0,
      isInline: true,
      product_id: 9495,
      description: '- Branchement électrique du moteur de la porte de garage.',
    },
    {
      id: 'Réglage fin de course',
      label: 'Réglage fin de course',
      value: 'Réglage fin de course',
      lst_price: 0,
      isInline: true,
      product_id: 9495,
      description: '- Réglage des fins de course de la porte de garage motorisée.',
    },
    {
      id: 'Mise en service',
      label: 'Mise en service',
      value: 'Mise en service',
      lst_price: 0,
      isInline: true,
      product_id: 9495,
      description: '- Mise en service et test de fonctionnement de la porte de garage.',
    },
    {
      id: 'Mise à la décharge',
      label: 'Mise à la décharge',
      value: 'Mise à la décharge',
      lst_price: 0,
      isInline: true,
      product_id: 9495,
      description: '- Mise à la décharge des éléments déposés.',
    },
    {
      id: 'Fermeture du coffre',
      label: 'Fermeture du capotage',
      value: 'Fermeture du coffre',
      lst_price: 0,
      isInline: true,
      product_id: 9495,
      description: '- Fermeture et remise en place du capotage / protection du mécanisme de la porte de garage.',
    },
  ],
};


const voletComplet = {
	id: 'VOLET_COMPLET',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Volet complet',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: false,
	options: [
		{
			id: 'pose_volet_complet',
			label: 'Pose volet complet',
			description: 'Pose complète d’un volet roulant avec réglages et essais finaux.',
			lst_price: 120,
		},
		{
			id: 'depose_volet_complet',
			label: 'Dépose volet complet',
			description: 'Dépose complète du volet roulant existant avec sécurisation.',
			lst_price: 80,
		},
	],
};
const tablier = {
	id: 'TABLIER',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Tablier',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: voletComplet,
	options: [
		{
			id: 'pose_tablier',
			label: 'Pose tablier',
			description: 'Pose du tablier du volet roulant avec alignement et réglages.',
			lst_price: 42,
		},
		{
			id: 'depose_tablier',
			label: 'Dépose tablier',
			description: 'Dépose du tablier existant avec précaution et mise en sécurité.',
			lst_price: 42,
		},
	],
};

const axeMotorise = {
	id: 'AXE_MOTORISE',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Axe motorisé',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: tablier,
	options: [
		{
			id: 'pose_axe_motorise',
			label: 'Pose axe motorisé',
			description: 'Pose d’un axe motorisé avec réglage et tests de fonctionnement.',
			lst_price: 68,
		},
		{
			id: 'depose_axe_motorise',
			label: 'Dépose axe motorisé',
			description: 'Dépose de l’axe motorisé existant avec sécurisation du coffre.',
			lst_price: 60,
		},
	],
};
const axeManuel = {
	id: 'AXE_MANUEL',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Axe manuel',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: axeMotorise,
	options: [
		{
			id: 'pose_axe_manuel',
			label: 'Pose axe manuel',
			description: 'Pose d’un axe manuel pour volet roulant avec réglage du tablier.',
			lst_price: 48,
		},
		{
			id: 'depose_axe_manuel',
			label: 'Dépose axe manuel',
			description: 'Dépose de l’axe manuel existant avec démontage sécurisé.',
			lst_price: 30,
		},
	],
};
const moteur = {
	id: 'MOTEUR',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Moteur',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: axeManuel,
	options: [
		{
			id: 'pose_moteur',
			label: 'Pose moteur',
			description: 'Pose d’un moteur pour volet roulant avec réglages et essais complets.',
			lst_price: 48,
		},
		{
			id: 'depose_moteur',
			label: 'Dépose moteur',
			description: 'Dépose du moteur existant avec sécurisation de l’installation.',
			lst_price: 40,
		},
	],
};
const manivelle = {
	id: 'MANIVELLE',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Manivelle',
	name: 'category',
	className: 'col-12',
	classGroup: 'SCategory',
	nextStep: false,
	nextStepData: moteur,
	options: [
		{
			id: 'pose_manivelle',
			label: 'Pose manivelle',
			description:
				'Pose d’une manivelle pour volet roulant, avec réglage et tests de fonctionnement.',
			lst_price: 48,
		},
		{
			id: 'depose_manivelle',
			label: 'Dépose manivelle',
			description: 'Dépose de la manivelle existante avec mise en sécurité du mécanisme.',
			lst_price: 25,
		},
	],
};


export default MainOuvreDataPorte;
